export abstract class IScriptOriginPublisher {
  abstract findThenPublish(
    scripts: HTMLCollectionOf<HTMLScriptElement>,
    scriptName: string,
  );
}
